import { Button } from '@magnetic/button';
import { useBoolean } from '@magnetic/hooks';
import React, { forwardRef } from 'react';
import { InputFrame } from './input-frame.js';
import { InputWithAnalytics } from './input-with-analytics.js';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const PasswordSuffix = /* @__PURE__ */ __name(({
  isPassword,
  suffix,
  toggle
}) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Button, {
  kind: "tertiary",
  onClick: toggle
}, isPassword ? "Show" : "Hide"), suffix), "PasswordSuffix");
const InputPassword = forwardRef(
  ({
    className,
    disabled,
    fixedWidth,
    invalid,
    label,
    onChange,
    onClear,
    prefix,
    size = "md",
    suffix,
    tooltip,
    value,
    ...rest
  }, ref) => {
    const { toggle, value: isPassword } = useBoolean(true);
    return /* @__PURE__ */ React.createElement(InputFrame, {
      className,
      disabled,
      fixedWidth,
      hasValue: !!value,
      invalid,
      label,
      onClear,
      prefix,
      size,
      suffix: /* @__PURE__ */ React.createElement(PasswordSuffix, {
        isPassword,
        suffix,
        toggle
      }),
      tooltip
    }, /* @__PURE__ */ React.createElement(InputWithAnalytics, {
      ...rest,
      disabled,
      label,
      onChange,
      ref,
      type: isPassword ? "password" : "text",
      value
    }));
  }
);
InputPassword.displayName = "Input.Password";

export { InputPassword };
//# sourceMappingURL=input-password.js.map
